import React from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTAButton } from "../components/CTAButton";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../data/content";

const PROCESS = [
  { n: "01", t: "Discover", d: "We map your data sources, workflows, and the questions your staff needs answered." },
  { n: "02", t: "Architect", d: "Clean schemas and relationships designed around athletics — not generic CRUD." },
  { n: "03", t: "Build", d: "Custom platform, dashboards, and search — deployed fast with your data inside." },
  { n: "04", t: "Support", d: "Ongoing maintenance, new features, and season-over-season data continuity." },
];

export default function Services() {
  return (
    <div>
      <PageHero
        testid="services-hero"
        overline="Services"
        title={<>Systems built<br />around your program</>}
        subtitle="From searchable record books to live performance analytics — we design, build, and maintain the data infrastructure athletics runs on."
      />

      <section className="py-24 bg-dark">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {SERVICES.map((s, i) => (
              <Reveal key={s.title} delay={(i % 2) * 0.08}>
                <div className="group bg-dark p-10 h-full hover:bg-dark-surface transition-colors duration-300">
                  <div className="flex items-start justify-between mb-6">
                    <s.icon className="w-9 h-9 text-teal group-hover:text-orange transition-colors duration-300" strokeWidth={1.5} />
                    <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl font-bold mb-3">{s.title}</h3>
                  <p className="text-slate-400 leading-relaxed mb-6">{s.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span key={t} className="font-mono text-[10px] uppercase tracking-widest text-teal border border-teal/30 px-2.5 py-1">{t}</span>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Marquee text="DESIGN · BUILD · DEPLOY" separator="·" />

      <section className="py-24 md:py-32 bg-dark-surface border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tighter mb-16">How we work</h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {PROCESS.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.08}>
                <div className="bg-dark-surface p-8 h-full">
                  <span className="font-display text-5xl font-black text-orange">{p.n}</span>
                  <h3 className="font-display text-2xl font-bold mt-4 mb-3">{p.t}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-14">
              <CTAButton to="/contact" variant="orange" data-testid="services-cta">Start a project</CTAButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
